module.exports = __webpack_public_path__ + "img/octagon-divide.7ff92fd6.svg";